import { FC, useEffect, useState } from 'react';
import useFetch from '@hooks/useFetch';
import useWindowSize from '@hooks/useWindowSize';
import useMounted from '@hooks/useMounted';
import BANNER_TYPES from './utils';
import CampaignBanner2 from './CampaignBanner2';
import { getGenericBanner } from './apiHelper';

export const getGenericBannerComponent = (type) => {
  switch (type) {
    case BANNER_TYPES.CAMPAIGN_BANNER_2:
      return CampaignBanner2;

    default:
      return null;
  }
};

type GenericBannerProps = {
  bannerUid: string;
};

const GenericBanner: FC<GenericBannerProps> = ({ bannerUid }) => {
  const { data } = useFetch(
    getGenericBanner(bannerUid),
    {},
    { revalidateOnMount: true }
  );

  const { isMobile } = useWindowSize();

  if (!data) return null;
  const Component = getGenericBannerComponent(
    data?.bannerData?.template?.templateType
  );

  const bannerData = {
    ...data.bannerData.templateValues,
    bannerUid
  };
  return <Component banner={bannerData} isMobile={isMobile} />;
};

type GenericBannerListProps = {
  block: {
    data: any;
  };
};

const GenericBannerList: FC<GenericBannerListProps> = ({ block: { data } }) => {
  const isMounted = useMounted();

  const { isMobile } = useWindowSize();

  if (!isMounted) return null;
  let dataMap = null;
  const { mobile, desktop } = data;
  if (isMobile) {
    dataMap = mobile;
  } else {
    dataMap = desktop;
  }
  if (!dataMap) return null;
  return dataMap.map(({ bannerUid }) => (
    <GenericBanner key={bannerUid} bannerUid={bannerUid} />
  ));
};

export default GenericBannerList;
